import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-sponsors",
  templateUrl: "./sponsors.component.html",
  styleUrls: ["./sponsors.component.scss"],
})
export class SponsorsComponent implements OnInit {
  constructor(private http: HttpClient) {}
  li: any;
  lis = [];
  lit: any;
  list = [];
  inv: any;
  invpart = [];
  inc: any;
  incpart = [];
  ven: any;
  venpart = [];
  eco: any;
  ecopart = [];
  outs: any;
  outpart = [];
  med: any;
  medpart = [];
  soc: any;
  socpart = [];
  ins: any;
  inspart = [];
  gov: any;
  govpart = [];
  brand: any;
  brandpart = [];
  accs: any;
  accpart = [];
  displayStyles = "block";

  assos: any;
  ngOnInit(): void {
    this.displayStyles = "block";
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .get(environment.API_URL + "getSponsors/")
      .subscribe((Response) => {
        this.li = Response;
        this.lis = this.li.spons;
        console.log(this.li);
        this.displayStyles = "none";
      });
    this.http.get(environment.API_URL + "invpart/").subscribe((Response) => {
      // console.log(Response)
      this.inv = Response;
      this.invpart = this.inv.asso;
    });
    this.http.get(environment.API_URL + "incpart/").subscribe((Response) => {
      // console.log(Response)
      this.inc = Response;
      this.incpart = this.inc.asso;
    });
    this.http.get(environment.API_URL + "venpart/").subscribe((Response) => {
      // console.log(Response)
      this.ven = Response;
      this.venpart = this.ven.asso;
    });
    this.http.get(environment.API_URL + "ecopart/").subscribe((Response) => {
      // console.log(Response)
      this.eco = Response;
      this.ecopart = this.eco.asso;
    });
    this.http.get(environment.API_URL + "outpart/").subscribe((Response) => {
      // console.log(Response)
      this.outs = Response;
      this.outpart = this.outs.asso;
    });
    this.http
      .get(environment.API_URL + "startupmediapart/")
      .subscribe((Response) => {
        // console.log(Response)
        this.accs = Response;
        this.accpart = this.accs.asso;
      });
    this.http.get(environment.API_URL + "medpart/").subscribe((Response) => {
      // console.log(Response)
      this.med = Response;
      this.medpart = this.med.asso;
    });
    this.http.get(environment.API_URL + "brandpart/").subscribe((Response) => {
      this.brand = Response;
      this.brandpart = this.brand.asso;
    });
    // this.http.get('https://api3.ecell.in/eureka24/socpart/')
    // .subscribe(Response => {
    //   this.soc=Response;
    //   this.socpart=this.soc.asso;
    // });
    this.http.get(environment.API_URL + "inspart/").subscribe((Response) => {
      // console.log(Response)
      this.ins = Response;
      this.inspart = this.ins.asso;
    });
    this.http.get(environment.API_URL + "govpart/").subscribe((Response) => {
      // console.log(Response)
      this.gov = Response;
      this.govpart = this.gov.asso;
    });
  }

  openLink(link: string | null, event: MouseEvent) {
    if (!link) {
      event.preventDefault();
    }
  }
}
